
import type { ReceiptApi } from "@/types/api/receipts";
import type { AllocationStatus, Receipt, PaymentMethod } from "@/types/payments";

function mapPaymentMethodApiToUi(apiMethod: string): PaymentMethod {
  const methodMap: Record<string, PaymentMethod> = {
    "bank_transfer": "bank_transfer",
    "credit_card": "credit_card",
    "direct_debit": "direct_debit",
    "cheque": "cheque",
    "cash": "cash",
  };
  return methodMap[apiMethod.toLowerCase()] ?? "bank_transfer";
}

export function mapReceiptApiToUi(apiReceipt: ReceiptApi): Receipt {
  return {
    id: apiReceipt.id,
    receiptNumber: apiReceipt.receiptNumber,
    customerId: apiReceipt.customerId,
    customerName: apiReceipt.customerName,
    customerAccountNumber: apiReceipt.customerAccountNumber,
    receiptDate: new Date(apiReceipt.receiptDate),
    receivedAmount: apiReceipt.receivedAmount,
    allocatedAmount: apiReceipt.allocatedAmount,
    unappliedAmount: apiReceipt.unappliedAmount,
    currency: apiReceipt.currency,
    paymentMethod: mapPaymentMethodApiToUi(apiReceipt.paymentMethod),
    paymentReference: apiReceipt.paymentReference,
    bankReference: apiReceipt.bankReference,
    externalId: apiReceipt.externalId,
    importedAt: apiReceipt.importedAt ? new Date(apiReceipt.importedAt) : new Date(),
    importBatchId: apiReceipt.importBatchId,
    notes: apiReceipt.notes,
    allocationStatus: (apiReceipt.allocationStatus ?? "unallocated") as AllocationStatus,
    hasPromise: apiReceipt.hasPromise,
    createdBy: apiReceipt.createdBy,
    createdAt: new Date(apiReceipt.createdAt),
    modifiedBy: apiReceipt.modifiedBy,
    modifiedAt: apiReceipt.modifiedAt ? new Date(apiReceipt.modifiedAt) : undefined,
  };
}
